import React from 'react';
import {Redirect} from 'react-router';
import Loadable from 'components/Loadable';

const companyProfile = {
  path: '/company-profile',
  component: Loadable({
    loader: () => import('../views/company-profile'),
  }),
  routes: [
    {
      exact: true,
      path: '/company-profile',
      component: () => <Redirect to="/company-profile/profile" />,
    },
    {
      exact: true,
      path: '/company-profile/profile',
      component: Loadable({
        loader: () => import('../views/company-profile/profile'),
      }),
    },
  ],
};

export default companyProfile;
